module.exports = require("./ms-BN");